var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white",
    fillOpacity: 0.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7778 19.0556L23.7862 17.0724C23.5008 16.5016 23.3581 16.2162 23.1452 16.0077C22.957 15.8233 22.7301 15.6831 22.481 15.5972C22.1993 15.5 21.8802 15.5 21.242 15.5H17.8444C16.8488 15.5 16.351 15.5 15.9707 15.6938C15.6362 15.8642 15.3642 16.1362 15.1938 16.4707C15 16.851 15 17.3488 15 18.3444V19.0556M15 19.0556H28.5111C30.0046 19.0556 30.7513 19.0556 31.3218 19.3462C31.8235 19.6019 32.2315 20.0098 32.4871 20.5116C32.7778 21.082 32.7778 21.8287 32.7778 23.3222V27.2333C32.7778 28.7268 32.7778 29.4735 32.4871 30.044C32.2315 30.5457 31.8235 30.9537 31.3218 31.2094C30.7513 31.5 30.0046 31.5 28.5111 31.5H19.2667C17.7732 31.5 17.0265 31.5 16.456 31.2094C15.9543 30.9537 15.5463 30.5457 15.2906 30.044C15 29.4735 15 28.7268 15 27.2333V19.0556Z",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.1573083b5d9795e562d9425feb49e7e4.svg";
export { ForwardRef as ReactComponent };